var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.715V7.125C17.25 9.3975 15.3975 11.25 13.125 11.25C10.8525 11.25 9 9.3975 9 7.125V5.25H7.8075C7.7625 5.25 7.71 5.2275 7.68 5.1975L6.615 4.1325C6.3675 3.885 6.0375 3.75 5.6925 3.75H2.0625C0.9225 3.75 0 4.6725 0 5.8125V15.1875C0 16.3275 0.9225 17.25 2.0625 17.25H15.9375C17.0775 17.25 18 16.3275 18 15.1875V7.3125C18 6.675 17.7075 6.0975 17.25 5.715Z",
    fill: "#8E8E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9.75C11.6775 9.75 10.5 8.5725 10.5 7.125V3.1875C10.5 2.25675 11.2575 1.5 12.1875 1.5C13.1175 1.5 13.875 2.25675 13.875 3.1875V6.9375C13.875 7.248 13.623 7.5 13.3125 7.5C13.002 7.5 12.75 7.248 12.75 6.9375V3.1875C12.75 2.877 12.4972 2.625 12.1875 2.625C11.8778 2.625 11.625 2.877 11.625 3.1875V7.125C11.625 7.95225 12.2977 8.625 13.125 8.625C13.9523 8.625 14.625 7.95225 14.625 7.125V2.0625C14.625 1.752 14.877 1.5 15.1875 1.5C15.498 1.5 15.75 1.752 15.75 2.0625V7.125C15.75 8.5725 14.5725 9.75 13.125 9.75Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/Attachments.13f525b4146d83a35f0307c2a5fb8b55.svg";
export { ForwardRef as ReactComponent };